export type OrderKind = 'register' | 'buy' | 'donate';

export const OrderType = {
  Inscription: 0,
  TShirt: 1,
  Jersey: 2,
  Donation: 3,
} as const;

export type OrderTypeValue = (typeof OrderType)[keyof typeof OrderType];

export interface CreateOrderInput {
  kind: OrderKind;
  email: string;
  phone: string;
  amount?: number;
  shirtType?: 'jersey' | 'tshirt';
  size: string;
  jerseyName?: string;
  jerseyNumber?: string;
}

export interface CreatedOrder {
  id: string;
  paymentUrl: string;
}

export interface UserOrder {
  id: string;
  type: number;
  status: number;
  size: string;
  jerseyName: string;
  jerseyNumber: string;
  donationAmount: string;
  paymentConfirmationId: string;
  createdAt: string;
}

export interface OrderCreator {
  createOrder(input: CreateOrderInput): Promise<CreatedOrder>;
}

export interface OrderReader {
  getOrdersByUserEmail(email: string): Promise<UserOrder[]>;
}

export interface OrderPaymentConfirmer {
  updateOrderConfirmationId(
    orderId: string,
    paymentConfirmationId: string
  ): Promise<boolean>;
}

